import React, { useState, useEffect, useRef } from "react";
import Otp from "../../common/component/otp-input";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import useValidation from "../../common/utils/validationRules";
import isEmpty from "lodash";
import CommonButton from "../../common/component/commonButton";
import { sendOtp, verifyOTP } from "../../service/action/actioncreator/LoginAction/LoginAction";
import CommonLoader from "../../common/component/commonLoader";
import { updatePassword } from "../../service/action/actioncreator/LoginAction/LoginAction";
import logoImg from "../../assests/images/sifo-lofo.png";
import { useLoader } from "../../common/component/LoaderProvider";
import { useToast } from "../../common/component/Toast";
import { useTranslation } from "react-i18next";
import CountdownTimer from '../../common/component/CountDownTimer';

const OtpVerification = () => {
  const buttonRef = useRef();
  const loading = useSelector((state) => state.loginReducer.verifyOtpLoading);
  const [notificationFlag, setNotificationFlag] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { validateField } = useValidation();
  const { showLoader, hideLoader } = useLoader();
  const { showToast } = useToast();
  const { t } = useTranslation("translation");
  const [count, setCount]=useState(false)
  const [otpCodeFlag, setOtpCodeFlag] = useState(false);
    const [otpSelectionFlag, setOtpSelectionFlag] = useState(false);
    const [timer,setTimer] =useState(120);
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    watch,
    setValue,
    clearErrors,
    reset,
  } = useForm();
  watch("otp");

  const onSubmit = () => {
    const id = localStorage.getItem("userId");
    const oldPassword = localStorage.getItem("oldpassword");
    const password = localStorage.getItem("password");
    let flag = false;
    let navigateFlag = false;
    let changePwFirstAccess = false;
    let payloadOne = {
      userId: parseInt(id),
      authenticationFor: "Update password",
      AccessIdentifier: "Validate",
      // authenticationType: 1,
      AuthenticationType: localStorage.getItem("authenticationType"),
    };
    let removeItem = true;


    if (oldPassword?.length > 0 && password?.length > 0) {
      var headers = {
        UserId: parseInt(id),
        OtpCode: getValues("otp")?.toString(),
        AuthenticationType: localStorage.getItem("authenticationType"),
        AuthenticationFor: "Update Password",
        AccessIdentifier: "Verify",
      };
      var payload = {
        userId: parseInt(id),
        oldPassword: oldPassword?.trim(),
        password: password?.trim(),
      };
      // dispatch(updatePassword(payload,headers,navigate,showLoader,hideLoader,flag,setNotificationFlag,payloadOne,navigateFlag))
      dispatch(
        updatePassword(
          payload,
          headers,
          navigate,
          showLoader,
          hideLoader,
          showToast,
          t,
          flag,
          setNotificationFlag,
          payloadOne,
          navigateFlag,
          changePwFirstAccess
        )
      );
    } else {
      var payload = {};
      var headers = {
        UserId: id,
        AuthenticationType: localStorage.getItem("authenticationType"),
        AuthenticationFor: "Login",
        OtpCode: getValues("otp")?.toString(),
        AccessIdentifier: "verify",
      };
      dispatch(
        verifyOTP(payload, headers, navigate, showLoader, hideLoader, showToast)
      );
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current.click();
    }
  };
  // Add event listener to the input
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  const resetOtpFn=()=>{
    // setTimer(120);

    reset()
    let navigateFlag = false;
    const authenticationType =localStorage?.getItem('authenticationType');
    const userId = localStorage?.getItem('userId');

    let payload = {
      userId:userId,
      authenticationFor: "Login",
      authenticationType: authenticationType,
    };
    dispatch(sendOtp(
      payload,
      navigate,
      showLoader,
      hideLoader,
      navigateFlag,
      setOtpSelectionFlag,
      setOtpCodeFlag,
      setTimer
    ))
  }

  return (
    <div className="main-container otp-img otp-footer otp-btn">
      <div className="login-container">
        <div className="login-box-otp text-center">
          <div className="display-flex">
            <img src={logoImg} alt="log-img" className="logo-img" />
          </div>
          <div className="mt-5 text-center fs-4 fw-bold">
            {/* 00:30 */}
            <CountdownTimer initialSeconds={timer} setTimer={setTimer} setCount={setCount} count={count} />            </div>
          <div className="mt-3">
            <Otp
              name="otp"
              setValue={setValue}
              getValues={getValues}
              control={control}
              errors={errors}
              clearErrors={clearErrors}
              validationFn={validateField}
              onOtpSubmit={(otp) => {
                console.log("Submitting OTP:", otp);
              }}
            />
          </div>

          {count && <p className="text-center otp-message mt-4 font-size-fs-6">
            {t("text_link_resend_otp")}{" "}
            <span className="underline pointer" onClick={resetOtpFn}>{t("text_posting")}</span>
          </p>}

          <CommonButton
            label={t("text_button_send")}
            inputStyle={true}
            buttonRef={buttonRef}
            disabled={getValues("otp")?.length < 6}
            onClick={handleSubmit(onSubmit)}
            className={
              "btn mt-3 btn-width btn-padding input-style-common text-white"
            }
            type="submit"
            variant={"success"}
          />
          <div className="mt-5">
            <hr />
            {isEmpty(errors) && (
              <>
                <div className="fw-bold mt-2 custom-text-break font-size-fs-3">
                  {t("text_send_code_message")}
                </div>
              </>
            )}
          </div>
          <CommonLoader loading={loading} />
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
